import React from 'react';
import {TaskView} from "dolphin-meridian-react-components";
import {ROUTE_PATH} from "../../routing";
import AppLoader from "../app-loader";
import Column from "@meridian/components/column";
import Workflow from "../../models/ui/workflow";
import {UseAppContext} from "../../context/use-app-context";
import AppAlert from "../app-alert";
import AppDataStore from "../../app-data";
import Picklist from "../../models/ui/picklist";
import {closeApp} from "../../bridge/utils";
import {interceptBackButton, interceptBackButtonStop} from "../../bridge/back-button";
import gateway from "../../network";
import ErrorCodes from "../../network/error-codes";

export default function DirectedPickEntry(props) {

    const appOptions = {onBackPressed: closeApp};

    React.useEffect(() => {
        interceptBackButton("picking");
        return interceptBackButtonStop;
    }, []);

    const {
        appState, alertActions, alertState,
        isLoaderVisible, showLoader, hideLoader
    } = UseAppContext(appOptions);

    const onClickGetPickList = async () => {
        showLoader();
        try {
            const picklistInfo = await gateway().assignTopPriorityPickList();
            // save picklist
            AppDataStore.savePicklist(Picklist.getInstance(picklistInfo));
            AppDataStore.saveWorkflow(Workflow.getInstanceFromItemList(picklistInfo.itemList));
            props.history.push(ROUTE_PATH.PRE_PICK_CONFIRMATION);
        } catch (e) {
            const message = ErrorCodes[e.message] || ErrorCodes.DEFAULT;
            alertActions.errorAlert(message);
            console.error(e);
        } finally {
            hideLoader();
        }
    }

    const tasks = [{
        title: "Get a picklist",
        description: "Pick packages from aisles for the assigned picklist",
        onClick: onClickGetPickList
    }, {
        title: "Enter a route code",
        description: "Pick a specific route by entering its route code",
        href: ROUTE_PATH.INPUT_ROUTE
    }];

    return <Column spacing={"none"}>
        <Column spacingInset={"small"}><AppAlert {...alertState} onClose={alertActions.removeAlert}/></Column>
        {isLoaderVisible && <AppLoader/>}
        <TaskView
            pageTitle={appState.showLoader ? "Select a pick task..." : "Select a pick task"}
            tasks={tasks}/>
    </Column>;
}


// WEBPACK FOOTER //
// ./src/components/pre-pick/directed-pick-entry.js